import React from 'react';
import Form from "react-bootstrap/Form";
import {Typeahead} from "react-bootstrap-typeahead";
import ChangeCheckContext from "../../../support/ChangeCheckContext";
import BooleanInput from "../../../formElements/BooleanInput";
import {FormCheck} from "react-bootstrap";
import SelectInput from "../../../formElements/SelectInput";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function InstrumentLoanSelector(props) {
    // this component has three main events - onChange, onBlur and onInputChange. When input changes, we need to update
    // state so that typing works correctly. However, this allows state to reach invalid values. Because of this, we use
    // second state, which keeps track of last valid value and if user stops typing without selecting valid value, last
    // valid option is returned back.
    const typeaheadRef = React.useRef(null);
    const [selected, setSelected] = React.useState(props.value)
    const [lastValid, setLastValid] = React.useState(props.value)
    const {disable} = React.useContext(ChangeCheckContext)
    const [isTyping, setIsTyping] = React.useState(false);
    const [instrumentCategory, setInstrumentCategory] = React.useState("demo")

    const instrumentCategoryOptions = {
        "all": "Všetky prístroje",
        "demo": "Demo prístroje",
        "demo-free": "Voľné demo prístroje"
    }

    React.useEffect(() => {
        if (!isTyping) {
            setSelected(props.value)
            setLastValid(props.value)
        }
    })

    function handleChange(selection) {
        // Handling change sets current value in the same way as input change, but also updates last valid value if
        // the selected instrument is valid. This ensures that only in the case of valid instruments, change of value will
        // be performed.
        if (selection[0] !== undefined) {
            if (selection[0] !== "") {
                setSelected(selection[0])
                setLastValid(selection[0])
            }
            typeaheadRef.current.blur();
            const event = {target: {value: selection[0]}}
            selectInstrument(event)
        }
    }

    function handleInputChange(value) {
        // In order to achieve correct typing, we need to update state on every change.
        setIsTyping(true)
        const newValue = value
        setSelected(newValue)
    }

    function handleBlur(event) {
        if (props.empty) {
            // last, empty instrument section needs to be handled like this, so that the selected value is not applied twice
            setSelected("")
        } else {
            // this returns last valid value if user stops typing without selecting valid value
            setSelected(lastValid)
        }
        setIsTyping(false)
    }

    function changeDemo(event) {
        const newValue = Object.keys(instrumentCategoryOptions).find(key => instrumentCategoryOptions[key] === event.target.value)
        setInstrumentCategory(newValue)
    }

    function getOptions(addEmpty) {
        if (props.data.Pristroje === undefined || props.data.Pristroje_options === undefined) {
            return []
        }
        let options = Object.values(props.data.Pristroje_options)
        let selected_instruments = props.data.Pristroje.map(item => (
            {"SNR": item.Pristroj.SNR, "Typ": item.Pristroj["Produkt"].Typ, "Demo": item.Pristroj.Demo}
        ))
        if (!options) {
            return []
        }
        options = options.filter(option =>
            !selected_instruments.some(instrument =>
                instrument.SNR === option.SNR && instrument.Typ === option["Produkt"].Typ)
        );
        if (instrumentCategory === "demo") {
            options = options.filter(option => option.Demo === true)
        } else if (instrumentCategory === "demo-free") {
            options = options.filter(option => option.Demo === true && option.Loans.length === 0)
        }
        options.forEach(option => {
            if (option.Demo === false) {
                option.backgroundColor = "black"
            } else if (option.Loans.length !== 0) {
                option.backgroundColor = "blue"
            } else {
                option.backgroundColor = "green"
            }
        })
        return options
    }

    function selectInstrument(event) {
        props.selectInstrument(event, props.instrumentIndex)
    }

    return (
        <>
            <Form.Group>
                {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
                <Row className="mt-3">
                    <Col className="col-6">
                        <Typeahead
                            positionFixed={true}
                            disabled={disable}
                            id="basic-typeahead-single"
                            labelKey="SNR"
                            renderMenuItemChildren={(option, props) => (
                                <div style={{color: option.backgroundColor}}>
                                    {`${option.SNR} - ${option.Produkt ? option.Produkt.Typ : ""} - ${option.Zakaznik ? option.Zakaznik : ""}`}
                                </div>
                            )}
                            ref={typeaheadRef}
                            onChange={(selection) => handleChange(selection)}
                            onBlur={handleBlur}
                            options={getOptions(props.empty)}
                            placeholder={"Vybrať prístroj"}
                            selected={[selected]} //since selected is expecting array, we need to turn value into array
                            onInputChange={handleInputChange}
                        />
                    </Col>
                    <Col className="col-2">
                        <label style={{color: "green"}}>Voľné demo</label>
                    </Col>
                    <Col className="col-2">
                        <label style={{color: "blue"}}>Demo</label>
                    </Col>
                    <Col className="col-2">
                        <label style={{color: "black"}}>Ostatné</label>
                    </Col>
                </Row>
                <div className="mt-3">
                    <SelectInput options={
                        Object.keys(instrumentCategoryOptions).map(key => instrumentCategoryOptions[key])
                    }
                                 onChange={changeDemo} value={instrumentCategoryOptions[instrumentCategory]}/>

                </div>
            </Form.Group>
        </>
    );
};

export default InstrumentLoanSelector;